import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {PatientSection} from '@/features/patients/components/patient-section/PatientSection'
import {ProjectPatientLivingConditionField} from '@/features/projects/components/project-form/project-patient-living-condition-field/ProjectPatientLivingConditionField'
import {ProjectPatientRehabilitationFacilityField} from '@/features/projects/components/project-form/project-patient-rehabilitation-facility-field/ProjectPatientRehabilitationFacilityField'
import {ProjectExtended} from '@/features/projects/types'
import {useMemo} from 'react'

export const EditProjectPatientFormSections = ({patient}: {patient: ProjectExtended['patient']}) => {
    const patientData = useMemo(() => {
        return {
            id: patient.id,
            fullName: patient.fullName,
            gender: patient.gender,
            birthDate: patient.birthDate,
            residenceAslDistrict: patient.residenceAslDistrict,
            domicileAslDistrict: patient.domicileAslDistrict
        }
    }, [patient])

    return (
        <Flexbox direction="column" gap={8} fullWidth>
            <PatientSection patient={patientData} />
            <Grid columns={2} gap={4} fullWidth>
                <ProjectPatientLivingConditionField />
                <ProjectPatientRehabilitationFacilityField />
            </Grid>
        </Flexbox>
    )
}
